import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const ContactUs = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [ContactUs, setContactUs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_EXPRESS_API}/getAllContactUs`
        );
        setContactUs(response?.data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleDel = async (delId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_EXPRESS_API}/deleteContactUs/${delId}`)
          .then((res) => {
            Swal.fire("Deleted!", "The item has been deleted.", "success");
            // Refresh the list after deletion
            setContactUs(ContactUs.filter((product) => product.id !== delId));
          })
          .catch((error) => {
            console.error("Error deleting product:", error);
            Swal.fire(
              "Error!",
              "There was a problem deleting the item.",
              "error"
            );
          });
      }
    });
  };

  console.log(ContactUs, "ContactUs");

  return (
    <>
      <Container className="px-0 py-7">
        {!loading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">All ContactUs</h3>

                  <div className="d-flex flex-row">
                    {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                    <Input
                      className="mr-4"
                      type="text"
                      placeholder="Search"
                      size="sm"
                    />
                    <Button
                      size="sm"
                      to="/admin/contactUs/addcontactUs"
                      tag={Link}
                      color="primary"
                      style={{
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }}
                    >
                      +Add
                    </Button>
                  </div>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">S.NO.</th>
                      <th scope="col">Name</th>
                      <th scope="col">Profile Image</th>
                      <th scope="col">Type</th>
                      <th scope="col">Designation</th>
                      <th scope="col">Phone No.</th>
                      <th scope="col">Whatapp No.</th>
                      <th scope="col">Email</th>
                      <th scope="col">Role</th>
                      <th scope="col">Priority</th>

                      {/* <th scope="col">BOARD/GRADE</th>
                      <th scope="col">Per KM Fare</th> */}
                      <th>Action</th>
                      <th scope="col" />
                    </tr>
                  </thead>

                  {ContactUs?.length > 0 &&
                    ContactUs?.map((item, index) => {
                      return (
                        <tbody>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>

                            <td>-</td>
                            <td>{item.type}</td>

                            <td>{item.designation}</td>
                            <td>{item.phoneNumber}</td>
                            <td>{item.whatsappNo}</td>
                            <td>{item.email}</td>

                            <td>{item.role}</td>
                            <td>{item.priority}</td>
                            <td
                              className="p-0 pr-4"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <UncontrolledTooltip
                                placement="top"
                                target="eyeTooltip"
                              >
                                edit
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  marginTop: "10px",
                                  display: "inline-block",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "30%", // Optional: Make it a circle
                                }}
                                id="eyeTooltip"
                                to="/admin/contactUs/editcontactUs"
                                // tag={Link}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </Link>

                              <UncontrolledTooltip
                                placement="top"
                                target="userTooltip"
                              >
                                Delete
                              </UncontrolledTooltip>
                              <p
                                style={{
                                  margin: "0 8px",
                                  fontSize: "15px",
                                  color: "red",
                                  marginTop: "10px",
                                  // backgroundColor: "#f5f5f5",
                                  display: "inline-block",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "20%", // Optional: Make it a circle
                                }}
                                onClick={() => handleDel(item.id)}
                                id="userTooltip"
                              >
                                <i className="fas fa-trash"></i>
                              </p>
                            </td>
                          </tr>
                          {/* {dataList?.data?.map((item, index) => {
    let currentDate = new Date(item.createdAt);
    let formattedDate = currentDate.toISOString().substring(0, 10);
    return (
      <tr key={item._id}>
        <td>{((currentPage-1) * perPage) + index + 1}</td>
        <td>{item?.name}</td>
        <td>{item?.message}</td>
        <td>{item?.contact}</td>
        <td>{item?.email}</td>
        <td>{formattedDate}</td>
        <td>
          <UncontrolledDropdown>
            <DropdownToggle
              className="btn-icon-only text-light"
              role="button"
              size="sm"
              color=""
              onClick={(e) => e.preventDefault()}
            >
              <i className="fas fa-ellipsis-v" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow " right>
              <DropdownItem
                onClick={() => handleDel(item._id)}
                className="text-danger"
              >
                <i className="fas fa-trash"></i> Delete
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    );
  })} */}
                        </tbody>
                      );
                    })}
                </Table>
                <CardFooter className="py-4">
                  {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </Container>
    </>
  );
};

export default ContactUs;
